module.exports = __webpack_public_path__ + "img/product-1.de7b2347.png";